import { render, staticRenderFns } from "./EditarPasta.vue?vue&type=template&id=670ab9e6&"
import script from "./EditarPasta.vue?vue&type=script&lang=js&"
export * from "./EditarPasta.vue?vue&type=script&lang=js&"
import style0 from "./EditarPasta.vue?vue&type=style&index=0&id=670ab9e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports